import React from 'react';
import classNames from 'classnames';

function NavbarRight(props) {
  const { className = null, children, ...otherProps } = props;
  const classes = classNames('ws-navbar__right', className);

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
}

export default NavbarRight;
